<template>
  <div class="stat-container">
      <!-- Header Row -->
      <div class="row">
        <div class="col-3">
          <font-awesome-icon
            icon="chart-line"
            class="stat-icon dont-print"
          />
        </div>
        <div class="col-7 pt-4">
          <span class="stat-title">{{ $t('contract_reports.observation_type') }}</span>
        </div>
        <div class="col-2 pt-4">
          <span class="stat-title">{{ $t('contract_reports.amount') }}</span>
        </div>
      </div>

      <!-- Observation Type Rows -->
        <div
          v-for="(observationType, index) in observationTypes"
          :key="index"
          class="col-12"
        >
          <div class="row">
            <div class="col-3"></div>
            <!-- Observation Type Name -->
            <div class="col-7">
              <span class="font-weight-bold">{{ observationType.name }}</span>
            </div>
            <!-- Observation Type Count -->
            <div class="col-2 text-right">
              <span>{{ observationType.count }}</span>
            </div>
          </div>
        </div>
  </div>
</template>

<script>

export default {
    name: "ObservationTypeSummary",
    props: {
        observationTypes: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data: function () {
        return {
            observationTypesVisible: false
        }
    }
}
</script>

